import { css, circle } from './draw-utils';
import type { ProceduralDef } from '../types';

const RING = 0xc77dff; // accretion violet

/**
 * Singularity — a black hole with a bright accretion ring and
 * lensing glow. The pull well is applied in code. docs/02 boss pool.
 */
export const bossSingularityBody: ProceduralDef = {
  key: 'boss/singularity/body',
  width: 160,
  height: 160,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;

    // Lensing glow
    const halo = ctx.createRadialGradient(c, c, 20, c, c, c);
    halo.addColorStop(0, 'rgba(199,125,255,0.5)');
    halo.addColorStop(0.6, 'rgba(199,125,255,0.15)');
    halo.addColorStop(1, 'rgba(199,125,255,0)');
    circle(ctx, c, c, c);
    ctx.fillStyle = halo;
    ctx.fill();

    // Accretion ring (tilted ellipse)
    ctx.save();
    ctx.translate(c, c);
    ctx.rotate(-0.4);
    ctx.scale(1, 0.42);
    ctx.beginPath();
    ctx.arc(0, 0, 52, 0, Math.PI * 2);
    ctx.lineWidth = 12;
    ctx.strokeStyle = css(RING);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(0, 0, 52, 0, Math.PI * 2);
    ctx.lineWidth = 4;
    ctx.strokeStyle = css(0xffe9ff);
    ctx.stroke();
    ctx.restore();

    // Event horizon — pure black core with a thin violet rim
    circle(ctx, c, c, 34);
    ctx.fillStyle = '#050208';
    ctx.fill();
    ctx.lineWidth = 2.5;
    ctx.strokeStyle = css(RING);
    circle(ctx, c, c, 33);
    ctx.stroke();
    void h;
  },
};
